/**
 * Created by yangxuanbin on 07/02/2018
 **/

export default function setRole(state={},action){
  switch (action.type){
    case "SET_ACTION" :
      return {
        ...state
      };
    case "CLEAN_ROLE":
      return {
        role:''
      };
    default:
      return {}
  }
}


// WEBPACK FOOTER //
// ./src/reduxModule/reducers/role.js